import React from 'react';
import { useSelector, StateProps } from 'react-redux';
import { Redirect } from 'react-router-dom';


interface AuthRouteProp {
  component:any
  render:any,
  children:any,
}


const AuthGuard: React.FC<AuthRouteProp> = (
  { component: Component, 
    render,
    children,
  }) => {
  const account = useSelector((state:StateProps) => state.account);

  if (account.user === undefined) {
    return <Redirect to="/" />;
  }


  return children;
}


export default AuthGuard;
